"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("@/helpers");
var _components = require("@/components");
var _validators = require("vuelidate/lib/validators");
var _vuex = require("vuex");
var _validate = require("@/utils/validate");
var _lodash = _interopRequireDefault(require("lodash"));
var _auth = require("@/utils/auth");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mockPurchase = {
  initialConsumption: 1,
  finalConsumption: null,
  price: 0,
  active: true,
  planType: 1,
  assetPlanId: null,
  digitalAssetId: null
};
var mockSales = {
  initialConsumption: 1,
  finalConsumption: null,
  price: 0,
  active: true,
  planType: 2,
  assetPlanId: null,
  digitalAssetId: null
};
var _default = exports.default = {
  components: {
    Card: _components.Card,
    AppInput: _components.AppInput,
    AppSelect: _components.AppSelect
  },
  props: {
    showWarning: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      idService: null,
      serviceForm: {},
      clientUser: null,
      containAnalitcs: false,
      form: {
        name: '',
        digitalAssetType: null,
        description: '',
        organizationId: null,
        sla: null,
        phone: null,
        email: null,
        webhook: '',
        urlDocumentation: '',
        serviceIntegration: '',
        businessUnitId: null,
        nicknames: [],
        nicknamesWebhook: [],
        reportId: '',
        ctid: '',
        processFile: false
      },
      fileLogo: null,
      fileSwagger: null,
      listRangesCost: [_objectSpread({}, mockPurchase)],
      listRangesSales: [_objectSpread({}, mockSales)],
      clientList: [],
      listBusinessUnits: []
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['listServiceTypes', 'listAllClients'])), {}, {
    logoValid: function logoValid() {
      if ((0, _validate.validURL)(this.serviceForm.logo)) return true;
      return false;
    },
    swaggerValid: function swaggerValid() {
      if ((0, _validate.validURL)(this.serviceForm.swagger)) return true;
      return false;
    }
  }),
  watch: {
    fileLogo: function () {
      var _fileLogo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(val && val.type)) {
                _context.n = 1;
                break;
              }
              if (!(val.type.indexOf('image/') <= -1)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, _helpers.messageHelper.error('Somente arquivos de imagens são aceitos'));
            case 1:
              this.form.logo = val;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function fileLogo(_x) {
        return _fileLogo.apply(this, arguments);
      }
      return fileLogo;
    }(),
    fileSwagger: function () {
      var _fileSwagger = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(val) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(val && val.type)) {
                _context2.n = 1;
                break;
              }
              if (!(val.type !== 'application/json')) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, _helpers.messageHelper.error('Somente arquivos JSON são aceitos'));
            case 1:
              this.form.swagger = val;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function fileSwagger(_x2) {
        return _fileSwagger.apply(this, arguments);
      }
      return fileSwagger;
    }(),
    clientUser: function () {
      var _clientUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.form.organizationId = id;
              if (id) {
                this.getBusinessUnits(id);
              }
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function clientUser(_x3) {
        return _clientUser.apply(this, arguments);
      }
      return clientUser;
    }()
  },
  created: function created() {
    var id = this.$route.params.id;
    if (id) {
      this.idService = id;
      this.getDetails();
    }
  },
  validations: function validations() {
    var _this = this;
    return {
      form: {
        name: {
          required: _validators.required
        },
        digitalAssetType: {
          required: _validators.required
        },
        description: {
          required: _validators.required
        },
        organizationId: {
          required: _validators.required
        },
        businessUnitId: {
          required: _validators.required
        },
        sla: {},
        phone: {
          required: _validators.required
        },
        email: {
          required: _validators.required
        },
        webhook: {},
        urlDocumentation: {},
        serviceIntegration: {},
        logo: {},
        swagger: {},
        nicknames: {},
        nicknamesWebhook: {},
        reportId: {
          required: (0, _validators.requiredIf)(function (value) {
            return !!_this.form.ctid;
          })
        },
        ctid: {
          required: (0, _validators.requiredIf)(function (value) {
            return !!_this.form.reportId;
          })
        },
        processFile: {}
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['uploadToS3', 'createService', 'updateService', 'fetchBusinessUnits', 'fetchDetailService', 'fetchPurchasePlan', 'createPurchasePlan', 'updatePurchasePlan', 'deletePurchasePlan', 'fetchSalesPlan', 'createSalesPlan', 'updateSalesPlan', 'deleteSalesPlan', 'createAnaliticPanel', 'updateAnaliticPanel', 'fetchReportIdService'])), {}, {
    getDetails: function () {
      var _getDetails = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var data, dataPurchase, dataSales, reports;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!this.idService) {
                _context4.n = 5;
                break;
              }
              _context4.n = 1;
              return this.fetchDetailService(this.idService);
            case 1:
              data = _context4.v;
              if (!data) {
                _context4.n = 5;
                break;
              }
              this.serviceForm = data;
              this.form.organizationId = data.organizationId;
              this.clientUser = data.organizationId;
              this.joinForms();

              // TODO: GET LISTS
              this.getBusinessUnits(data.organizationId);
              _context4.n = 2;
              return this.fetchPurchasePlan(this.idService);
            case 2:
              dataPurchase = _context4.v;
              if (dataPurchase && dataPurchase.length) this.listRangesCost = dataPurchase;
              _context4.n = 3;
              return this.fetchSalesPlan(this.idService);
            case 3:
              dataSales = _context4.v;
              if (dataSales && dataSales.length) this.listRangesSales = dataSales;
              _context4.n = 4;
              return this.fetchReportIdService(this.idService);
            case 4:
              reports = _context4.v;
              if (reports !== 'report_not_exist') {
                this.containAnalitcs = true;
                this.form.reportId = reports.reportId;
                this.form.ctid = reports.ctid;
              }
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function getDetails() {
        return _getDetails.apply(this, arguments);
      }
      return getDetails;
    }(),
    joinForms: function joinForms() {
      for (var _i = 0, _Object$entries = Object.entries(this.form); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 1),
          key = _Object$entries$_i[0];
        if (this.serviceForm.hasOwnProperty(key)) {
          this.form[key] = this.serviceForm[key];
          if (key === 'digitalAssetType') {
            this.form[key] = this.serviceForm[key]._id;
          }
        }
      }
    },
    addNewLineCost: function addNewLineCost() {
      var arrayOrder = _lodash.default.orderBy(this.listRangesCost, ['finalConsumption'], ['desc']);
      var lastRegister = arrayOrder[0];
      var valueInitital = lastRegister.finalConsumption || 0;
      this.listRangesCost.push({
        initialConsumption: Number(valueInitital) + 1,
        finalConsumption: null,
        price: 0,
        active: true,
        planType: 1,
        assetPlanId: null,
        digitalAssetId: this.idService
      });
    },
    addNewLineSale: function addNewLineSale() {
      var arrayOrder = _lodash.default.orderBy(this.listRangesSales, ['finalConsumption'], ['desc']);
      var lastRegister = arrayOrder[0];
      var valueInitital = lastRegister.finalConsumption || 0;
      this.listRangesSales.push({
        initialConsumption: Number(valueInitital) + 1,
        finalConsumption: null,
        price: 0,
        active: true,
        planType: 2,
        assetPlanId: null,
        digitalAssetId: this.idService
      });
    },
    removeLineCost: function removeLineCost(index) {
      this.listRangesCost.splice(index, 1);
    },
    removeLineSales: function removeLineSales(index) {
      this.listRangesSales.splice(index, 1);
    },
    addNewTypeService: function addNewTypeService() {
      this.$buefy.modal.open({
        parent: this,
        component: _components.ModalFormNewTypeService,
        hasModalCard: true,
        customClass: 'modal-form-new-type-service-component',
        trapFocus: true,
        canCancel: ['escape', 'outside']
      });
    },
    uploadFiles: function () {
      var _uploadFiles = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(file, type) {
        var self;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              self = this;
              return _context6.a(2, new Promise(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(resolve, reject) {
                  var data, resp;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.n) {
                      case 0:
                        data = {
                          image: file,
                          typeFile: type || ''
                        };
                        _context5.n = 1;
                        return self.uploadToS3(data);
                      case 1:
                        resp = _context5.v;
                        if (resp) resolve(resp);else reject();
                      case 2:
                        return _context5.a(2);
                    }
                  }, _callee5);
                }));
                return function (_x6, _x7) {
                  return _ref.apply(this, arguments);
                };
              }()));
          }
        }, _callee6, this);
      }));
      function uploadFiles(_x4, _x5) {
        return _uploadFiles.apply(this, arguments);
      }
      return uploadFiles;
    }(),
    checkForm: function () {
      var _checkForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(e) {
        var _this2 = this;
        var payload, urlFileImageLogo, urlFileImageSwagger, operationAnalitic, operation, message, listRangesCost, listRangesCostUpdate, listRangesSales, listRangesSalesUpdate, _dataUser$user, _dataUser$user2, _dataUser$user3, _dataUser$user4, promisseCost, promisseSales, dataUser, data, _dataUser$user5, _dataUser$user6, _dataUser$user7, _dataUser$user8, promisseCostUpdate, promisseSalesUpdate, _dataUser;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              e.preventDefault();
              this.$v.$touch();
              if (!this.$v.$invalid) {
                _context9.n = 1;
                break;
              }
              this.$buefy.toast.open({
                duration: 5000,
                message: "Por favor, verifique os campos <b>obrigat\xF3rios</b>!",
                position: 'is-top',
                type: 'is-danger'
              });
              _context9.n = 15;
              break;
            case 1:
              payload = this.form;
              if (!this.fileLogo) {
                _context9.n = 3;
                break;
              }
              _context9.n = 2;
              return this.uploadFiles(this.fileLogo, 'zip');
            case 2:
              urlFileImageLogo = _context9.v;
              if (urlFileImageLogo) payload.logo = urlFileImageLogo;
            case 3:
              if (!this.fileSwagger) {
                _context9.n = 5;
                break;
              }
              _context9.n = 4;
              return this.uploadFiles(this.fileSwagger, 'json');
            case 4:
              urlFileImageSwagger = _context9.v;
              if (urlFileImageSwagger) payload.swagger = urlFileImageSwagger;
            case 5:
              operationAnalitic = this.createAnaliticPanel;
              operation = this.createService;
              message = 'Serviço cadastrado com sucesso!';
              listRangesCost = [];
              listRangesCostUpdate = [];
              listRangesSales = [];
              listRangesSalesUpdate = [];
              if (!this.idService) {
                _context9.n = 8;
                break;
              }
              message = 'Serviço alterado com sucesso!';
              payload.idService = this.idService;
              operation = this.updateService;
              if (this.containAnalitcs) operationAnalitic = this.updateAnaliticPanel;
              promisseCost = this.listRangesCost.map(function (i) {
                var item = i;
                item.digitalAssetId = _this2.idService;
                item.initialConsumption = Number(item.initialConsumption);
                item.finalConsumption = Number(item.finalConsumption);
                if (item.initialConsumption && item.finalConsumption) {
                  if (item.assetPlanId) {
                    listRangesCostUpdate.push(item);
                  } else {
                    delete item.assetPlanId;
                    listRangesCost.push(item);
                  }
                }
                return item;
              });
              _context9.n = 6;
              return Promise.all(promisseCost);
            case 6:
              promisseSales = this.listRangesSales.map(function (i) {
                var item = i;
                item.digitalAssetId = _this2.idService;
                item.initialConsumption = Number(item.initialConsumption);
                item.finalConsumption = Number(item.finalConsumption);
                if (item.initialConsumption && item.finalConsumption) {
                  if (item.assetPlanId) {
                    listRangesSalesUpdate.push(item);
                  } else {
                    delete item.assetPlanId;
                    listRangesSales.push(item);
                  }
                }
                return item;
              });
              _context9.n = 7;
              return Promise.all(promisseSales);
            case 7:
              dataUser = (0, _auth.getUser)(); // set config GA
              this.$gtag.config({
                'user_id': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user = dataUser.user) === null || _dataUser$user === void 0 ? void 0 : _dataUser$user._id,
                'user_name': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user2 = dataUser.user) === null || _dataUser$user2 === void 0 ? void 0 : _dataUser$user2.name
              });
              // set event user
              this.$gtag.event('update_service', {
                'event_category': 'service',
                'event_label': 'alterar serviço',
                'value': {
                  'user_id': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user3 = dataUser.user) === null || _dataUser$user3 === void 0 ? void 0 : _dataUser$user3._id,
                  'user_name': dataUser === null || dataUser === void 0 ? void 0 : (_dataUser$user4 = dataUser.user) === null || _dataUser$user4 === void 0 ? void 0 : _dataUser$user4.name
                }
              });
            case 8:
              _context9.n = 9;
              return operation(payload);
            case 9:
              data = _context9.v;
              if (!data) {
                _context9.n = 15;
                break;
              }
              if (!listRangesCost.length) {
                _context9.n = 10;
                break;
              }
              _context9.n = 10;
              return this.createPurchasePlan(listRangesCost);
            case 10:
              if (!listRangesSales.length) {
                _context9.n = 11;
                break;
              }
              _context9.n = 11;
              return this.createSalesPlan(listRangesSales);
            case 11:
              if (!listRangesCostUpdate.length) {
                _context9.n = 12;
                break;
              }
              promisseCostUpdate = listRangesCostUpdate.map(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(i) {
                  var item, assetPlanId;
                  return _regenerator().w(function (_context7) {
                    while (1) switch (_context7.n) {
                      case 0:
                        item = i;
                        assetPlanId = item.assetPlanId;
                        delete item.assetPlanId;
                        _context7.n = 1;
                        return _this2.updatePurchasePlan({
                          payload: item,
                          assetPlanId: assetPlanId
                        });
                      case 1:
                        return _context7.a(2, item);
                    }
                  }, _callee7);
                }));
                return function (_x9) {
                  return _ref2.apply(this, arguments);
                };
              }());
              _context9.n = 12;
              return Promise.all(promisseCostUpdate);
            case 12:
              if (!listRangesSalesUpdate.length) {
                _context9.n = 13;
                break;
              }
              promisseSalesUpdate = listRangesSalesUpdate.map(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(i) {
                  var item, assetPlanId;
                  return _regenerator().w(function (_context8) {
                    while (1) switch (_context8.n) {
                      case 0:
                        item = i;
                        assetPlanId = item.assetPlanId;
                        delete item.assetPlanId;
                        _context8.n = 1;
                        return _this2.updateSalesPlan({
                          payload: item,
                          assetPlanId: assetPlanId
                        });
                      case 1:
                        return _context8.a(2, item);
                    }
                  }, _callee8);
                }));
                return function (_x0) {
                  return _ref3.apply(this, arguments);
                };
              }());
              _context9.n = 13;
              return Promise.all(promisseSalesUpdate);
            case 13:
              if (!this.form.reportId) {
                _context9.n = 14;
                break;
              }
              _context9.n = 14;
              return operationAnalitic({
                reportId: this.form.reportId,
                ctid: this.form.ctid,
                businessUnit: this.form.businessUnitId,
                digitalAsset: this.idService
              });
            case 14:
              this.$buefy.toast.open({
                message: message,
                type: 'is-success',
                duration: 5000
              });
              this.$emit('update:showWarning', true);
              _dataUser = (0, _auth.getUser)(); // set config GA
              this.$gtag.config({
                'user_id': _dataUser === null || _dataUser === void 0 ? void 0 : (_dataUser$user5 = _dataUser.user) === null || _dataUser$user5 === void 0 ? void 0 : _dataUser$user5._id,
                'user_name': _dataUser === null || _dataUser === void 0 ? void 0 : (_dataUser$user6 = _dataUser.user) === null || _dataUser$user6 === void 0 ? void 0 : _dataUser$user6.name
              });
              // set event user
              this.$gtag.event('add_service', {
                'event_category': 'service',
                'event_label': 'novo serviço',
                'value': {
                  'user_id': _dataUser === null || _dataUser === void 0 ? void 0 : (_dataUser$user7 = _dataUser.user) === null || _dataUser$user7 === void 0 ? void 0 : _dataUser$user7._id,
                  'user_name': _dataUser === null || _dataUser === void 0 ? void 0 : (_dataUser$user8 = _dataUser.user) === null || _dataUser$user8 === void 0 ? void 0 : _dataUser$user8.name
                }
              });
            case 15:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function checkForm(_x8) {
        return _checkForm.apply(this, arguments);
      }
      return checkForm;
    }(),
    confirmDelete: function confirmDelete(type, item, idx) {
      var action = this.deletePurchase;
      if (type === 'sales') action = this.deletePurchase;
      if (item.assetPlanId) {
        this.$buefy.modal.open({
          parent: this,
          component: _components.ModalWarning,
          hasModalCard: true,
          trapFocus: true,
          props: {
            text: 'Deseja realmente exluir',
            action: action,
            name: 'esse item',
            idItem: item.assetPlanId,
            idSecond: idx
          }
        });
      } else {
        if (type === 'cost') this.removeLineCost(idx);else this.removeLineSales(idx);
      }
    },
    deletePurchase: function () {
      var _deletePurchase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(id, index) {
        var data;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return this.deletePurchasePlan(id);
            case 1:
              data = _context0.v;
              if (data) {
                this.removeLineCost(index);
                this.getDetails();
              }
            case 2:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function deletePurchase(_x1, _x10) {
        return _deletePurchase.apply(this, arguments);
      }
      return deletePurchase;
    }(),
    deleteSales: function () {
      var _deleteSales = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(id, index) {
        var data;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return this.deleteBusinessUnits(id);
            case 1:
              data = _context1.v;
              if (data) {
                this.removeLineSales(index);
                this.getDetails();
              }
            case 2:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function deleteSales(_x11, _x12) {
        return _deleteSales.apply(this, arguments);
      }
      return deleteSales;
    }(),
    getBusinessUnits: function () {
      var _getBusinessUnits = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(idOrganization) {
        var data;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return this.fetchBusinessUnits(idOrganization);
            case 1:
              data = _context10.v;
              if (data) {
                this.listBusinessUnits = data;
              }
            case 2:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function getBusinessUnits(_x13) {
        return _getBusinessUnits.apply(this, arguments);
      }
      return getBusinessUnits;
    }(),
    toUpper: function toUpper(val, item) {
      this.form[item] = val.toUpperCase();
    }
  })
};